import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteInventoryApi,
  deleteInventoryItemApi,
  deleteVendorApi,
  deleteVendorLogoApi,
  getInventoryApi,
  getInventorysApi,
  getVendorApi,
  getVendorsApi,
  postInventoryApi,
  postInventoryItemApi,
  postVendorApi,
  postVendorLogoApi,
  updateInventoryApi,
  updateInventoryItemApi,
  updateVendorApi,
} from "../../api/ecommerce/InventoryApi";

const initialState = {
  inventory: {},
  inventorys: [],
  inventoryItem: {},
  vendor: {},
  vendors: [],
  vendorLogo: {},
  loading: false,
  saving: false,
  deleting: false,
};

export const getInventory = createAsyncThunk(
  "inventory/getInventory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getInventoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateInventory = createAsyncThunk(
  "inventory/updateInventory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateInventoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postInventory = createAsyncThunk(
  "inventory/postInventory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postInventoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteInventory = createAsyncThunk(
  "inventory/deleteInventory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteInventoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postInventoryItem = createAsyncThunk(
  "inventory/postInventoryItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postInventoryItemApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getInventorys = createAsyncThunk(
  "inventory/getInventorys",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getInventorysApi();
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateInventoryItem = createAsyncThunk(
  "inventory/updateInventoryItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateInventoryItemApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteInventoryItem = createAsyncThunk(
  "inventory/deleteInventoryItem",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteInventoryItemApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getVendor = createAsyncThunk(
  "inventory/getVendor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getVendorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateVendor = createAsyncThunk(
  "inventory/updateVendor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateVendorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postVendor = createAsyncThunk(
  "inventory/postVendor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postVendorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteVendor = createAsyncThunk(
  "inventory/deleteVendor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteVendorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postVendorLogo = createAsyncThunk(
  "inventory/postVendorLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postVendorLogoApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteVendorLogo = createAsyncThunk(
  "inventory/deleteVendorLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteVendorLogoApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getVendors = createAsyncThunk(
  "inventory/getVendors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getVendorsApi();
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInventory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventory.fulfilled, (state, action) => {
      state.inventory = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getInventory.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getInventorys.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventorys.fulfilled, (state, action) => {
      state.inventorys = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getInventorys.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(postInventory.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postInventory.fulfilled, (state, action) => {
      state.inventory = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postInventory.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(updateInventory.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateInventory.fulfilled, (state, action) => {
      state.inventory = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(updateInventory.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(postInventoryItem.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postInventoryItem.fulfilled, (state, action) => {
      state.inventoryItem = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postInventoryItem.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(updateInventoryItem.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateInventoryItem.fulfilled, (state, action) => {
      state.inventoryItem = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(updateInventoryItem.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(deleteInventory.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteInventory.fulfilled, (state) => {
      state.deleting = false;
    });
    builder.addCase(deleteInventory.rejected, (state) => {
      state.deleting = false;
    });

    builder.addCase(deleteInventoryItem.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteInventoryItem.fulfilled, (state) => {
      state.deleting = false;
    });
    builder.addCase(deleteInventoryItem.rejected, (state) => {
      state.deleting = false;
    });

    builder.addCase(getVendor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVendor.fulfilled, (state, action) => {
      state.vendor = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getVendor.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getVendors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVendors.fulfilled, (state, action) => {
      state.vendors = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getVendors.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(postVendor.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postVendor.fulfilled, (state, action) => {
      state.vendor = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postVendor.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(updateVendor.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateVendor.fulfilled, (state, action) => {
      state.vendor = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(updateVendor.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(deleteVendor.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteVendor.fulfilled, (state) => {
      state.deleting = false;
    });
    builder.addCase(deleteVendor.rejected, (state) => {
      state.deleting = false;
    });

    builder.addCase(postVendorLogo.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postVendorLogo.fulfilled, (state, action) => {
      state.vendorLogo = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postVendorLogo.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(deleteVendorLogo.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteVendorLogo.fulfilled, (state) => {
      state.deleting = false;
    });
    builder.addCase(deleteVendorLogo.rejected, (state) => {
      state.deleting = false;
    });
  },
});

export default inventorySlice.reducer;
